/** API route map: URLS.Controller.EmployeeSocialMedia */
export const EmployeeSocialMedia = {
      Name: 'EmployeeSocialMedia/',
};
